import { useState } from "react";

export const useFilters = (initialFilter: {
  searchValue: string;
  data?: any;
}) => {
  const [filter, setFilter] = useState(initialFilter);

  return { filter, setFilter };
};
